import React from "react"
import _ from "lodash"
import I18n from "@helper/i18nInstance"

import "./PersonalityTestPointsToResult.scss"

const PointsToResult: React.FC<{points_to_result: Quiz.Api.PointsToResult}> = ({points_to_result}) => {
  return (
    <div className="neo__pointsToResult__wrapper">
      <h2>{I18n.t("quiz.quiz_eval.personality_test.points_to_result_title")}</h2>
      {_.map(points_to_result, (p, index) => {
        return <div key={index} className="neo__pointsToResult">
          <h3>{p.points}</h3>
          <p dangerouslySetInnerHTML={{__html: p.result}} />
        </div>
      })}
    </div>
  )
}

export default PointsToResult
